import { render, staticRenderFns } from "./FlashMessage.vue?vue&type=template&id=07e509b0&scoped=true&"
import script from "./FlashMessage.vue?vue&type=script&lang=ts&"
export * from "./FlashMessage.vue?vue&type=script&lang=ts&"
import style0 from "./FlashMessage.vue?vue&type=style&index=0&id=07e509b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e509b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
